import { OrderRefusalModule } from '../refusal/order-refusal.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { OverlayModule } from '@angular/cdk/overlay';
import { A11yModule } from '@angular/cdk/a11y';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClientInputModule } from '../../client/client-input.module';
import { SelectorModule } from '../../selector/selector.module';
import { WarehouseModule } from '../../warehouse/warehouse.module';
import { PaymentLinkDialogModule } from '../../docs/client-invoice/payment-link-dialog/payment-link-dialog.module';
import { TerminalPaymentModule } from '../../terminal-payment/terminal-payment.module';
import { OrderPaymentDialogComponent } from '../order-payment-dialog/order-payment-dialog.component';
import { ListComponent } from './list.component';
import { OrderDefaultsDialogComponent } from './order-defaults-dialog.component';
import { OrderSupplySourceComponent } from './order-supply-source.component';
import { OrderCancelDialogComponent } from './order-cancel-dialog.component';

// No routes: the same list is used by /orders and the client profile.
@NgModule({
  declarations: [ListComponent, OrderPaymentDialogComponent, OrderDefaultsDialogComponent, OrderSupplySourceComponent, OrderCancelDialogComponent],
  imports: [OrderRefusalModule, CommonModule, FormsModule, ReactiveFormsModule, RouterModule, ClipboardModule, OverlayModule, A11yModule,
    MomentDateModule, MatButtonModule, MatDatepickerModule, MatDialogModule,
    MatFormFieldModule, MatIconModule, MatInputModule, MatMenuModule,
    MatProgressBarModule, MatProgressSpinnerModule, MatSelectModule, MatSidenavModule,
    MatSlideToggleModule, MatTableModule, MatTooltipModule, ClientInputModule, SelectorModule,
    WarehouseModule, PaymentLinkDialogModule, TerminalPaymentModule],
  exports: [ListComponent, OrderPaymentDialogComponent]
})
export class OrderListModule {}
